/*
 * Author: Danny Ehlers
 * Date: 3/17/2019
 * Cap main component. Included idle logout process and global error handling.
 */

import { Component, ChangeDetectorRef, OnInit, AfterViewInit, AfterContentChecked, OnDestroy } from '@angular/core';
//import { OpenIdConnectService } from './services/security/open-id-connect.service';
import { AuthService } from './services/security/auth.service';
import { CapNotificationService } from './core/services/cap-notification.service';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { SettingsProviderService } from './settings-provider.service';
import { SignalRService } from './common/services/signal-r.service';
import { CapSpinnerService } from './core/cap-spinner/services/cap-spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterContentChecked, OnDestroy {
  title = 'Conservatorship Accounting Portal';
  subscription: any;
  startTimeoutSubscription: any;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  showIdleWarning: boolean = false;

  constructor(
    private authService: AuthService,
    private capNotificationService: CapNotificationService,
    private confirmationService: ConfirmationService,
    private router: Router,
    //private capSpinnerService: CapSpinnerService,
    private idle: Idle,
    private settingsProviderService: SettingsProviderService,
    public signalRService: SignalRService,
    private cdref: ChangeDetectorRef) {
    this.router.events.subscribe(() => {
      switch (true) {
        case event instanceof ProgressEvent: {
          //this.capSpinnerService.spinnerShow();
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  };

  showConfirmPopup(): boolean {
     return !this.signalRService.hideDialog;
  }

  ngOnInit() {

    this.signalRService.startConnection();
    this.signalRService.addDataListener();

    //DE (9/5/2018): Created a inactivity timeout process.
    this.startTimeoutSubscription = this.capNotificationService.startTimeoutActivated$.subscribe(
      capNotificationActivated => {
        console.log(this.settingsProviderService.configuration);
        // sets an idle timeout of 5 seconds, for testing purposes.
        this.idle.setIdle(+this.settingsProviderService.adminSettings.sessionTimeout);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.

        this.idle.setTimeout(+this.settingsProviderService.adminSettings.sessionWarningTimeout);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeout.subscribe(() => {
          this.authService.logout();
        });
        this.idle.onTimeoutWarning.subscribe((countdown) => {
          if (this.authService.currentAuthUser) {
            if (!this.showIdleWarning)
              this.idle.clearInterrupts();
            this.idleState = '<h6>Do you want to continue your session?</h6><br/>For security reasons, your session will time out in ' + countdown + ' seconds unless you continue.';
            this.showIdleWarning = true;
          }
        });

        this.reset();
      });

    // DE (8/29/2018): The service below is used to display any http errors that occur
    // in the application. It allows the user to reload the page in an attempt to recover.
    this.subscription = this.capNotificationService.errorActivated$.subscribe(
      capNotificationActivated => {
        // DE (8/29/2018): Ensure messages being return from the controllers
        // are converted to generic system message. We don't want to provide
        // the user with real system errors that are unhandled in the controller.
        let errorStatus = capNotificationActivated.errorStatus;
        let errorMessage = capNotificationActivated.errorMessage;
        this.confirmationService.confirm({
          message: `A system error has occurred.<br/><br/>
                    Error Status: ${ errorStatus}<br/>
                    Error Message: ${ errorMessage}<br/><br/>
                    Do you want to try to reload the page?`,
          accept: () => {
            let currentUrl = this.router.url;
            //DE (8/29/2018): The hack below will force a full redirect. This will ensure ngOnInit will fire in calling components.
            this.router.navigateByUrl('/temporary').then(() => this.router.navigateByUrl(currentUrl));
          },
          reject: () => {
            //Do nothing. User clicked Cancel.
          }
        });
        ////bring error alert front by setting z-index more
      });

  }

  // ngOnInit() {
  //  var path = window.location.pathname;
  //  if (path != "/signin-oidc") {
  //    if (!this.openIdConnectService.userAvailable) {
  //      this.openIdConnectService.triggerSignIn();
  //    }
  //  }
  // }

  // signin(event): void {
  //  debugger;
  //  var path = window.location.pathname;
  //  if (path != "/signin-oidc") {
  //    if (!this.openIdConnectService.userAvailable) {
  //      this.openIdConnectService.triggerSignIn();
  //    }
  //  }
  //  event.preventDefault();
  //  event.stopPropagation();
  // }

  reset() {
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.showIdleWarning = false;
  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  //Copied from CUP repo
  //Check if browser is eligible
  checkBrowserCompatibility() {
    //check if IE
    return !(window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1);
  }
}
